/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RescheduleQueue/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AppointmentQueue from './AppointmentQueue/index'
import AppointmentQueueEmpty from './AppointmentQueueEmpty/index'
import DraggingState from './DraggingState/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function RescheduleQueue({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/RescheduleQueue"
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="RescheduleQueue.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-1qglud': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-2-1qglud': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-3-1qglud': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-1qglud': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbc-5-1qglud': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Reschedule Queue"
 color={dtColorsNeutral900}
/>
</div>
<div
  data-testid="RescheduleQueue.Vertical"
  data-view-path={viewPath}
 id="appointment-queue-target"
 style={{'--pl-3-1qglud': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-4-1qglud': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-1-1qglud': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-2-1qglud': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<AppointmentQueue
  viewPath={`${viewPath}/AppointmentQueue`}
/>
<AppointmentQueueEmpty
  viewPath={`${viewPath}/AppointmentQueueEmpty`}
/>
<DraggingState
  viewPath={`${viewPath}/DraggingState`}
/>
</div>
{children}
</React.Fragment>)
}